import {
  GET_ADMINS,
  GET_ADMINS_FAIL,
  GET_ADMINS_SUCCESS,
  POST_ADD_ADMIN,
  POST_ADD_ADMIN_SUCCESS,
  POST_ADD_ADMIN_FAIL,
  DELETE_ADMIN,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAIL,
  CREATE_MANAGER,
  CREATE_MANAGER_SUCCESS,
  CREATE_MANAGER_FAIL,
  GET_WORKSPACE_DETAILS,
  GET_WORKSPACE_DETAILS_SUCCESS,
  GET_WORKSPACE_DETAILS_FAIL,
  UPDATE_WORKSPACE_DETAILS,
  UPDATE_WORKSPACE_DETAILS_SUCCESS,
  UPDATE_WORKSPACE_DETAILS_FAIL,
  UPDATE_WORKSPACE_USER,
  UPDATE_WORKSPACE_USER_SUCCESS,
  UPDATE_WORKSPACE_USER_FAIL,
  DELETE_WORKSPACE_USER,
  DELETE_WORKSPACE_USER_SUCCESS,
  DELETE_WORKSPACE_USER_FAIL,
  TOGGLE_ACCOUNT_STATUS,
  TOGGLE_ACCOUNT_STATUS_SUCCESS,
  TOGGLE_ACCOUNT_STATUS_FAIL,
} from "./actionTypes";

export const toggleAccountStatus = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: TOGGLE_ACCOUNT_STATUS,
  payload: { data, onSuccess, onError },
});

export const toggleAccountStatusSuccess = data => ({
  type: TOGGLE_ACCOUNT_STATUS_SUCCESS,
  payload: data,
});

export const toggleAccountStatusFail = error => ({
  type: TOGGLE_ACCOUNT_STATUS_FAIL,
  payload: error,
});

export const updateWorkspace = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_WORKSPACE_DETAILS,
  payload: { data, onSuccess, onError },
});

export const updateWorkspaceSuccess = data => ({
  type: UPDATE_WORKSPACE_DETAILS_SUCCESS,
  payload: data,
});

export const updateWorkspaceFail = error => ({
  type: UPDATE_WORKSPACE_DETAILS_FAIL,
  payload: error,
});

export const deleteWorkspaceUser = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_WORKSPACE_USER,
  payload: { data, onSuccess, onError },
});

export const deleteWorkspaceUserSuccess = data => ({
  type: DELETE_WORKSPACE_USER_SUCCESS,
  payload: data,
});

export const deleteWorkspaceUserFail = error => ({
  type: DELETE_WORKSPACE_USER_FAIL,
  payload: error,
});

export const updateWorkspaceUser = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_WORKSPACE_USER,
  payload: { data, onSuccess, onError },
});

export const updateWorkspaceUserSuccess = data => ({
  type: UPDATE_WORKSPACE_USER_SUCCESS,
  payload: data,
});

export const updateWorkspaceUserFail = error => ({
  type: UPDATE_WORKSPACE_USER_FAIL,
  payload: error,
});

export const createManager = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: CREATE_MANAGER,
  payload: { data, onSuccess, onError },
});

export const createManagerSuccess = data => ({
  type: CREATE_MANAGER_SUCCESS,
  payload: data,
});

export const createManagerFail = error => ({
  type: CREATE_MANAGER_FAIL,
  payload: error,
});

export const workspaceDetails = data => ({
  type: GET_WORKSPACE_DETAILS,
  payload: data,
});

export const workspaceDetailsSuccess = data => ({
  type: GET_WORKSPACE_DETAILS_SUCCESS,
  payload: data,
});

export const workspaceDetailsFail = error => ({
  type: GET_WORKSPACE_DETAILS_FAIL,
  payload: error,
});

export const getadmin = () => ({
  type: GET_ADMINS,
});

export const getadminSuccess = data => ({
  type: GET_ADMINS_SUCCESS,
  payload: data,
});

export const getadminFail = error => ({
  type: GET_ADMINS_FAIL,
  payload: error,
});

export const addAdmin = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: POST_ADD_ADMIN,
  payload: { data, onSuccess, onError },
});

export const addAdminSuccess = data => ({
  type: POST_ADD_ADMIN_SUCCESS,
  payload: data,
});

export const addAdminFail = error => ({
  type: POST_ADD_ADMIN_FAIL,
  payload: error,
});

export const deleteAdmin = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_ADMIN,
  payload: { data, onSuccess, onError },
});

export const deleteAdminSuccess = data => ({
  type: DELETE_ADMIN_SUCCESS,
  payload: data,
});

export const deleteAdminFail = error => ({
  type: DELETE_ADMIN_FAIL,
  payload: error,
});
